export default __webpack_public_path__ + "static/media/guard1.99b4a552.png";